import { useMutation, useQueryClient } from '@tanstack/react-query'

import { Platforms, PLATFORMS } from '../../../models'
import { request } from '../../../../../lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const setCampaignsProtectionMode = async ({
  accountId,
  connectionId,
  adAccountId,
  protectAll,
  platform,
}: {
  accountId: number
  connectionId: number
  adAccountId: number
  protectAll: boolean
  platform: Platforms
}) => {
  const platformName = platform === PLATFORMS.GOOGLE ? platform : 'facebook'
  return (await request({
    url: `/accounts/${accountId}/${platformName}/${connectionId}/ad-accounts/${adAccountId}/mode`,
    method: 'PUT',
    data: { protectAll },
  })) as string[] | Error
}

export const useSetCampaignsProtectionMode = ({
  connectionId,
  adAccountId,
  platform,
}: {
  connectionId: number
  adAccountId: number
  platform: Platforms
}) => {
  const queryClient = useQueryClient()
  const { accountId } = useUserStore()
  return useMutation({
    mutationFn: ({ protectAll }: { protectAll: boolean }) =>
      setCampaignsProtectionMode({ accountId, connectionId, adAccountId, protectAll, platform }),
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['getPlatformsConnections'] })
    },
  })
}
